import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import ReactHtmlParser from 'react-html-parser';

import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import BookList from 'rebook/apps/books/components/BookList';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import * as SeriesDetailActions from 'rebook/apps/catalog/actions/SeriesDetailActions';
import { Author } from 'rebook/apps/catalog/models';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';

import styles from './style.scss';


class SeriesDetailView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    this.props.SeriesDetailActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.SeriesDetailActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(SeriesDetailActions.fetchInitialData(match));
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.SeriesDetailActions.fetchBookList({ pageNumber });
  }

  onChangeSubscription(subscriptionId) {
    this.props.SeriesDetailActions.fetchBookList({ subscriptionId });
  }

  onChangeBookType(bookType) {
    this.props.SeriesDetailActions.fetchBookList({ bookType });
  }

  onResetFilters() {
    this.props.SeriesDetailActions.fetchBookList({
      subscriptionId: null,
      bookType: null,
    });
  }

  render() {
    const { series, books, pageNumber, lastPageNumber, subscriptionId, bookType } = this.props.seriesDetail;
    const seriesBookCount = get(series, 'counters.books', null);
    const seriesDescription = get(series, 'description', null);
    const seriesName = series ? `Серия «${series.name}»` : null;
    const seriesAuthor = series && series.author ? new Author(series.author) : null;
    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Библиотека', url: '/catalog/' },
          { text: `${seriesName}`, url: '' },
        ]} />
        <CatalogHeader title={seriesName} bookCount={seriesBookCount} />
        <div className={styles.author}>
          {seriesAuthor && (
            <Link to={seriesAuthor.getLink()} className={styles.author}>
              <CroppedImage
                type="resized"
                height="48"
                className={styles.photo}
                src={seriesAuthor.photo} />
              <div className={styles.authorInfo}>
                <div className={styles.authorName}>{seriesAuthor.cover_name}</div>
                <div>Автор серии</div>
              </div>
            </Link>
          )}
        </div>
        {seriesDescription && (
          <div className={styles.description}>
            <TextTruncate content={seriesDescription} collapseLabel="Свернуть">
              {ReactHtmlParser(seriesDescription)}
            </TextTruncate>
          </div>
        )}
        <div className={styles.filter}>
          <CatalogFilter
            isOrderEnabled={false}
            subscriptionId={subscriptionId}
            bookType={bookType}
            isResultEmpty={books && books.length === 0}
            onChangeSubscription={(value) => this.onChangeSubscription(value)}
            onChangeBookType={((value) => this.onChangeBookType(value))}
            onResetFilter={()=>this.onResetFilters()} />
        </div>
        {!books
          ? <BookList books={[...Array(5)]} />
          : this.renderFilteredBooks(books)
        }
        {lastPageNumber > 1 && (
          <ContextPagination
            onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
            currentPage={pageNumber}
            lastPage={lastPageNumber} />
        )}
      </div>
    );
  }

  renderFilteredBooks(books) {
    return (books.length ? <BookList books={books} /> : <EmptyFilterResult />);
  }
}

SeriesDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      seriesSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    seriesDetail: state.seriesDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeriesDetailActions: bindActionCreators(SeriesDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SeriesDetailView);
